import { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function ListISEEValidated(props) {
  const apiToken = useContext(TokenContext);
  const [ISEEList, setISEEList] = useState();
  const [ISEEListTemp, setISEEListTemp] = useState();
  const [ISEEListValidated, setISEEListValidated] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [ISEEId, setISEEId] = useState();

  useEffect(() => {
    setLoading(false);
    Repo.getIseeListValidated(apiToken)
      .then((response) => {
        setISEEListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const deleteIsee = async () => {
    Repo.deleteIsee(apiToken, ISEEId)
      .then((response) => {
        if (response.status == 204) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div>
        <h1>Lista ISEE</h1>

        <table className="table table-striped mt-5">
          <thead>
            <tr>
              <th scope="col">Nome cittadino</th>
              <th scope="col">Codice Fiscale</th>
              <th scope="col">Data inserimento</th>
               <th scope="col">Stato</th>
              <th scope="col">Anno</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {ISEEList &&
              ISEEList.length > 0 &&
              ISEEList.map((x, index) => (
                <tr key={index} index={index}>
                  {/* <th scope="row">{x.name}</th> */}
                  <th scope="row">
                    {x.user.firstName} {x.user.lastName}
                  </th>
                  <td>{x.user.fiscalCode}</td>
                  <td>{x.date}</td>
                 {/*  <td>
                    {x.value &&
                      parseFloat(x.value).toLocaleString("it-IT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{" "}
                    €
                  </td>*/}
                  <td>
                    {x.state == "VALIDATED" ? (
                      <>
                        <b className="text-success">
                          <svg className="icon icon-success">
                            <use href={`${iconSprite}#it-check-circle`} />
                          </svg>{" "}
                          ACCETTATO
                        </b>
                      </>
                    ) : (
                      <b className="text-danger">
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-close-circle`} />
                        </svg>{" "}
                        {x.state}
                      </b>
                    )}
                  </td>
                  <td>{y.year}</td>
                  <td>
                    <Link
                      to={"/ISEE_verificati/visualizza_isee?idIsee=" + x.id}
                    >
                      <button
                        className="btn btn-outline-primary p-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Visualizza"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {ISEEListTemp && (
        <Pagination
          items={ISEEListTemp}
          setCurrentItems={setISEEList}
          itemsPerPage={5}
        ></Pagination>
      )}

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteIsee()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListISEEValidated;
